<template>
  <SmallPopup show :showClose="false" cardClass="min-w-80 max-w-[min(90vw,26.25rem)] bg-popover-solid p-4">
    <div class="flex flex-col items-center gap-1 self-center text-center">
      <slot v-if="showIcon" name="icon">
        <div class="mb-2 flex size-11 items-center justify-center rounded-full bg-red-soft">
          <i class="tr tr-warning text-xl text-red"></i>
        </div>
      </slot>
      <div class="text-group font-bold text-text">{{ title || $t('common.Unsaved_changes') }}</div>
      <div class="text-body text-text-muted">{{ message || $t('common.There_are_unsaved_changes_in_this_comment') }}</div>
    </div>
    <div class="mt-2 flex gap-2">
      <SimpleButton class="flex-1" :text="cancelText || $t('common.Continue_editing')" @click="$emit('cancel')" />
      <SimpleButton class="flex-1" red :text="confirmText || $t('common.Drop_changes')" @click="$emit('confirm')" />
      <SimpleButton v-if="saveText" class="flex-1" variant="accent" :text="saveText" @click="$emit('save')" />
    </div>
  </SmallPopup>
</template>

<script setup>
import SimpleButton from '@/components/elements/SimpleButton.vue';
import SmallPopup from '@/components/elements/SmallPopup.vue';

defineProps({
  showIcon: { type: Boolean, default: true },
  // empty defaults fall back to translated texts in the template
  title: { type: String, default: '' },
  message: { type: String, default: '' },
  cancelText: { type: String, default: '' },
  confirmText: { type: String, default: '' },
  saveText: { type: String, default: '' },
});
defineEmits(['cancel', 'confirm', 'save']);
</script>
